import { FormattedMessage } from 'react-intl';
const UnlimitedPages = () => {
	return (
		<div>
			<p>
				<FormattedMessage
					id="ConfluencePricingPageTeam24.features.unlimitedPages.content.body"
					defaultMessage="Pages are used to create, share, and edit knowledge. These are living documents you can create and update for almost anything – from project plans, meeting notes, policies and more. You can create as many pages as you need."
				/>
			</p>
		</div>
	);
};
export default UnlimitedPages;
